import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import { dateFilter, dateFilterOptions, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

DialogDownloadExcelFile.propTypes = {
    filter: PropTypes.object,
    onDownload: PropTypes.func,
};

function DialogDownloadExcelFile({ filter, onDownload }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    useEffect(() => {
        setSelectedValue(filter?.dateFilter ?? dateFilter.baMuoiNgayGanNhat);
        setStartDate(filter?.from ?? getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'));
        const start = moment(filter?.from);
        const end = moment(filter?.to);
        const maxEndDate = start.clone().add(12, 'months').format('YYYY-MM-DD');
        if (end.isAfter(maxEndDate)) {
            setSelectedValue(dateFilter.tuyChon);
            setEndDate(maxEndDate);
        } else {
            setEndDate(filter?.to ?? getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'))
        }
    }, [filter])

    const selectedName = useMemo(() => {
        return _.find(dateFilterOptions, (item) => item.value === selectedValue)?.name;
    }, [selectedValue]);

    useEffect(() => {
        const arr = getDateFilterOption(selectedValue);
        if (_.isArray(arr) && arr.length === 2) {
            const sStartDate = arr[0].format('YYYY-MM-DD');
            const sEndDate = arr[1].format('YYYY-MM-DD');
            setStartDate(sStartDate);
            setEndDate(sEndDate);
        }
    }, [selectedValue]);


    // MARK: ---- METHODS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        const start = moment(startDate);
        const end = moment(endDate);
        const maxEndDate = start.clone().add(12, 'months');
        if (end.isAfter(maxEndDate)) {
            ToastHelper.showError('Thời gian kết thúc không được vượt quá 12 tháng kể từ ngày bắt đầu');
            return;
        }

        const params = _.pickBy(
            {
                ..._.omit(filter, ['limit', 'page']),
                dateFilter: selectedValue,
                from: startDate,
                to: endDate,
                limit: 1000000,
            },
            (value) => value != null && value !== ''
        );

        try {
            setLoading(true);
            onDownload(params);
        } catch (error) {
            ToastHelper.showError('Có lỗi xảy ra khi tải xuống: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    const onCancel = () => {
        AppCustomDialogHelper.hide();
    };

    return (
        <div className=''>
            <div className='row p-4'>
                <div className='col-12 pb-4'>
                    {UIHelper.buildFormLabel('Chọn khoảng thời gian')}
                    <KTBSDropdown
                        toggleElement={
                            <button
                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                type="button"
                            >
                                {selectedName}
                            </button>
                        }
                        selectedValue={selectedValue}
                        dropdownMenuItems={dateFilterOptions}
                        dropdownMenuClassName="overflow-auto w-100"
                        dropdownMenuStyle={{
                            maxHeight: '30vh',
                        }}
                        onChange={(value) => {
                            setSelectedValue(value);
                        }}
                    />
                </div>
                <div className='col-6 pr-2'>
                    {UIHelper.buildFormLabel('Ngày bắt đầu')}
                    <KTFormInput
                        name="startDate"
                        value={startDate}
                        onChange={(value) => setStartDate(value)}
                        enableCheckValid
                        type={KTFormInputType.date}
                        placeholder={'DD/MM/YYYY'}
                        isValid={Utils.isValid(startDate)}
                        isTouched={readyToValidate}
                        feedbackText={!Utils.isValid(startDate) && 'Vui lòng chọn thời gian bắt đầu'}
                        additionalInputClassName="pr-3"
                        maxTime={new Date().toISOString()}
                    />
                </div>
                <div className='col-6 pl-2'>
                    {UIHelper.buildFormLabel('Ngày kết thúc')}
                    <KTFormInput
                        name="endDate"
                        value={endDate}
                        onChange={(value) => setEndDate(value)}
                        enableCheckValid
                        type={KTFormInputType.date}
                        placeholder={'DD/MM/YYYY'}
                        isValid={Utils.isValid(endDate)}
                        isTouched={readyToValidate}
                        feedbackText={!Utils.isValid(endDate) && 'Vui lòng chọn thời gian kết thúc'}
                        additionalInputClassName="pr-3"
                        minTime={startDate}
                        maxTime={new Date().toISOString()}
                    />
                </div>
            </div>
            {/* footer */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    'Tải xuống',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogDownloadExcelFile;